export type KeyboardShortcutKey =
  | "open_overview"
  | "push_to_talk"
  | "mute_microphone"
  | "next_page"
  | "previous_page"
  | "like"
  | "dislike"
  | "agree"
  | "disagree"
  | "laugh"
  | "wow"
  | "love"
  | "clap"
  | "yes"
  | "no"
  | "hand_raise"
  | "next_student"
  | "previous_student"
  | "focus_comment"
  | "assess_with_ai";

export type KeyboardShortcutCategoryKey =
  | "general"
  | "audio"
  | "page_navigation"
  | "reactions"
  | "participation"
  | "assessment_mode";

export type KeyboardShortcut = {
  label: KeyboardShortcutKey;
  keys: string[];
  instructorOnly?: boolean;
};

export type KeyboardShortcutCategory = {
  title: KeyboardShortcutCategoryKey;
  shortcuts: KeyboardShortcut[];
};

export const KEYBOARD_SHORTCUT_CATEGORIES: KeyboardShortcutCategory[] = [
  {
    title: "general",
    shortcuts: [{ label: "open_overview", keys: ["Mod", "K"] }],
  },
  {
    title: "audio",
    shortcuts: [
      { label: "push_to_talk", keys: ["Ctrl"] },
      { label: "mute_microphone", keys: ["Shift", "M"] },
    ],
  },
  {
    title: "page_navigation",
    shortcuts: [
      { label: "next_page", keys: ["Shift", "→"] },
      { label: "previous_page", keys: ["Shift", "←"] },
    ],
  },
  {
    title: "reactions",
    shortcuts: [
      { label: "like", keys: ["Shift", "1"] },
      { label: "dislike", keys: ["Shift", "2"] },
      { label: "agree", keys: ["Shift", "3"] },
      { label: "disagree", keys: ["Shift", "4"] },
      { label: "laugh", keys: ["Shift", "5"] },
      { label: "wow", keys: ["Shift", "6"] },
      { label: "love", keys: ["Shift", "7"] },
      { label: "clap", keys: ["Shift", "8"] },
    ],
  },
  {
    title: "participation",
    shortcuts: [
      { label: "yes", keys: ["Y"] },
      { label: "no", keys: ["N"] },
      { label: "hand_raise", keys: ["H"] },
    ],
  },
  {
    title: "assessment_mode",
    shortcuts: [
      // Shift+Arrow is also used for page navigation, which is hidden while assessing.
      // If both components are mounted in a future context, one keypress would trigger both actions.
      { label: "next_student", keys: ["Shift", "→"], instructorOnly: true },
      { label: "previous_student", keys: ["Shift", "←"], instructorOnly: true },
      { label: "focus_comment", keys: ["Shift", "C"], instructorOnly: true },
      { label: "assess_with_ai", keys: ["Shift", "A"], instructorOnly: true },
    ],
  },
];
